module.exports = __webpack_public_path__ + "img/ipad-jp-2.9bbe992.jpg";